"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.CSS = void 0;
const menu_style_1 = require("../../components/menu/menu.style");
exports.CSS = {
    container: 'c-FormMigrateCollections',
    isLoading: 'c-FormMigrateCollections--IsLoading',
    content: 'c-FormMigrateCollections__Content',
    contentSecond: 'c-FormMigrateCollections__Content__second',
    list: 'c-FormMigrateCollections__List',
    menu: 'c-FormMigrateCollections__Menu',
    body: 'c-FormMigrateCollections__Body',
    warningTitle: 'c-FormMigrateCollections__Warning',
    warningBody: 'c-FormMigrateCollections__Warning__Body'
};
exports.Style = {
    [exports.CSS.container]: {
        width: '700px'
    },
    [exports.CSS.isLoading]: {
        display: 'flex',
        'justify-content': 'center'
    },
    [exports.CSS.warningTitle]: {
        color: 'red',
        'font-size': '2rem',
        'padding-bottom': '1rem'
    },
    [exports.CSS.warningBody]: {
        'padding-bottom': '1rem'
    },
    [exports.CSS.body]: {
        'padding-bottom': '1rem'
    },
    [exports.CSS.list]: {
        'list-style-type': 'none',
        'padding-left': 0
    },
    [exports.CSS.menu]: {
        width: '600px',
        position: 'absolute',
        [`& .${menu_style_1.CSS.menu}`]: {
            right: 'auto',
            width: '100%'
        }
    }
};
//# sourceMappingURL=collection.form.migrate.modal.style.js.map